<template>
    <div class="p-3 videos-list">

        <!-- Course Information -->
        <div class="container-xl">

            <videos-header :user="user"
                           :course="course"
                           :videos="videos"
                           :schedule="schedule"
                           :current-segment="currentSegment">
            </videos-header>

            <div v-if="isCompleted" class="alert alert-success">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <span class="font-weight-bold">{{ __('Course Completed') }}!  </span> {{ __('See you in the class on') }} <span class="font-weight-bold" v-text="descriptiveDate(schedule.date)"></span>.
                    </div>
                    <a v-if="data.quiz_password"
                       class="btn btn-danger btn-sm"
                       target="_blank"
                       :href="`/quiz?password=${data.quiz_password}&user_id=${user.id}`"
                       v-text="__('Access Quiz')">
                    </a>
                </div>
            </div>

            <div v-else class="alert alert-info">
               <div class="d-flex justify-content-between align-items-center">
                   <div>
                       You must complete this video and the quiz before the day of the class <span class="font-weight-bold" v-text="descriptiveDate(schedule.date)"></span>.
                   </div>
                   <a v-if="data.quiz_password"
                      class="btn btn-danger btn-sm"
                      target="_blank"
                      :href="`/quiz?password=${data.quiz_password}&user_id=${user.id}`"
                      v-text="__('Access Quiz')">
                   </a>
               </div>
            </div>

            <div class="row list-wrapper">

                <videos-list :current-segment="currentSegment" :segments="videoSegmentsList" :course="course" @segment="changeVideo"></videos-list>

                <div class="col-md-8" >
                    <video ref="videoPlayer" id="my_video_1" class="video-js vjs-default-skin"
                           width="100%" controls>
                        <source :src="currentSegment.model.url">
                    </video>
                </div>

            </div>

        </div>

    </div>

</template>
<script>

import videojs from 'video.js';

export default {

    props: {
        data: {
            type: Object,
            required: false,
        }
    },

    data() {
        return {
            saveDataInterval: '',
            player: null,
            currentSegment: null,
            schedule: this.data.schedule,
            course: this.data.schedule.schedulable,
            user: this.data.user,
            videos: this.data.user.assigned.videos,
            options: {
                controls: true,
                aspectRatio: "16:9",
                playbackRates: [1, 1.5, 2],
                poster: this.data.schedule.schedulable.image
            },
        }
    },

    created() {
        this.currentSegment = this.videos.segments[this.videos.current_video];
    },

    mounted() {
        this.player = videojs(this.$refs.videoPlayer, this.options);
        if (this.currentSegment.status != 'Completed') {
            this.player.controlBar.progressControl.disable();
            this.player.currentTime(this.currentSegment.time_elapsed);
        }
        this.player.on('playing', event => {
            this.onPlayerPlaying('started')
        })
        this.player.on('ended', event => {
            this.onPlayerEnded('completed')
        })
        this.player.on('pause', event => {
            this.onPlayerPause('pause')
        })
        if (!App.config.debug) {
            window.oncontextmenu = function () {
                console.log("Right Click Disabled");
                return false;
            }
        }
    },

    methods: {
        onPlayerEnded(action) {
            let data = {
                "currentTime": this.player.currentTime(),
                "video": this.currentSegment,
                "action": action,
                "duration": this.player.duration(),
            }
            App.request().put(`/schedules-course/${this.schedule.id}/videos`, data)
                .then(response => {
                    this.videos = response.data.videos;
                    clearInterval(this.saveDataInterval);
                    this.playNextVideo(this.videos.current_video);
                }).catch(errors => {
                Toast.error(errors)
            })
        },

        onPlayerPause(action) {
            clearInterval(this.saveDataInterval);
        },

        onPlayerPlaying(action) {
            this.saveDataInterval = setInterval(() => {
                let data = {
                    "currentTime": this.player.currentTime(),
                    "video": this.currentSegment,
                    "action": action,
                    "duration": this.player.duration(),
                }
                App.request().put(`/schedules-course/${this.schedule.id}/videos`, data)
                    .then(response => this.videos = response.data.videos)
                    .catch(errors => Toast.error(errors.response.data.message))

            }, 3000);
        },

        changeVideo(segment, key) {
            let indexInList = _.findIndex(this.videoSegmentsList, s => {
                return s.model.slug == key;
            })

            // If is not the first element in the list
            if (indexInList > 0) {
                // // get previus element of array
                var positionBefore = indexInList - 1;

                if (this.videoSegmentsList[positionBefore].status == 'Completed') {
                    this.currentSegment = this.videoSegmentsList[indexInList];
                    this.player.src({"type": "video/mp4", "src": this.currentSegment.model.url});

                    if (this.currentSegment.status != 'Completed') {
                        this.player.controlBar.progressControl.disable();
                    } else {
                        this.player.controlBar.progressControl.enable();
                    }
                    this.player.load();
                } else {
                    Toast.error('You must complete the previous videos to continue.');
                }
            } else {
                // If is the first one
                this.currentSegment = this.videoSegmentsList[indexInList];
                this.player.src({"type": "video/mp4", "src": this.currentSegment.model.url});
                this.player.controlBar.progressControl.enable();
                this.player.load();
            }
        },

        playNextVideo(currentVideo) {
            var segments = this.videos.segments;
            Object.keys(segments).forEach((value, index, array) => {

                if (array[index] == currentVideo) {
                    if (index < (array.length - 1)) {
                        var nextPosition = array[index + 1];
                        var nextVideo = segments[nextPosition];

                        this.currentSegment = segments[nextPosition];
                        this.videos.current_video = nextVideo.model.title;

                        Alert.interval(this.__('The next video starts in <strong></strong> seconds.'), 3000).then(() => {

                            this.player.src({"type": "video/mp4", "src": this.currentSegment.model.url});
                            this.player.load();
                            if (this.currentSegment.status != 'Completed') {
                                this.player.controlBar.progressControl.disable();
                            }

                            this.player.play();

                        }).catch(errors => {
                        })
                    }
                }
            });
        },

        toFixed(num) {
            return num.toFixed(2);
        }
    },

    computed: {

        videoSegmentsList() {
            return _.orderBy(this.videos.segments, s => {
                return s.model.order
            });
        },

        isCompleted() {
            return this.videos.total_progress == 100;
        }
    },
}
</script>
